/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Placements_Vibebids_Feature_LabelInputs */

const en_directory_promotion_placements_vibebids_feature_label = /** @type {(inputs: Directory_Promotion_Placements_Vibebids_Feature_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VibeBids feature`)
};

const zh_directory_promotion_placements_vibebids_feature_label = /** @type {(inputs: Directory_Promotion_Placements_Vibebids_Feature_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VibeBids 精选位`)
};

/**
* | output |
* | --- |
* | "VibeBids feature" |
*
* @param {Directory_Promotion_Placements_Vibebids_Feature_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_placements_vibebids_feature_label = /** @type {((inputs?: Directory_Promotion_Placements_Vibebids_Feature_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Placements_Vibebids_Feature_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_placements_vibebids_feature_label(inputs)
	return zh_directory_promotion_placements_vibebids_feature_label(inputs)
});
export { directory_promotion_placements_vibebids_feature_label as "directory.promotion.placements.vibebids-feature.label" }